<i18n locale="en">
{
  "pages": {
    "account": "Account",
    "invoices": "Invoices",
    "payouts": "Payouts",
    "subscriptions": "Subscriptions"
  }
}
</i18n>

<template>
  <DropdownNav :nav-items="navItems" />
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'

import DropdownNav, {
  type DropdownNavItem,
} from '@/components/Navigation/DropdownNav.vue'
import { useFeatureFlags } from '@/utils/useFeatureFlags'

const { t } = useI18n()

const FeatureFlags = useFeatureFlags()

const navItems = ref<DropdownNavItem[]>([
  {
    label: t('pages.payouts'),
    to: { name: 'brand.billing.payouts' },
  },
  {
    label: t('pages.invoices'),
    to: { name: 'brand.billing.invoices' },
  },
  {
    label: t('pages.subscriptions'),
    to: { name: 'brand.billing.methods' },
  },
])

if (FeatureFlags.isEnabled('hermes.paymentsAccountManagement')) {
  navItems.value.push({
    label: t('pages.account'),
    to: { name: 'brand.billing.account' },
  })
}
</script>
